(ns bp-clients.tv-app.router
  "Namespace to initializes the app's router"
  (:require
   [re-frame.core :as rf]
   [reitit.frontend :as rtf]
   [reitit.frontend.easy :as rfe]))

(goog-define use-fragment true)

(def ^:private do-nav rfe/navigate)
(def ^:private do-replace rfe/replace-state)

(def routes
  (rtf/router
   ["/"
    ["index"
     {:name ::home}]
    ["register"
     {:name ::register}]
    ["login"
     {:name ::login}]
    ["logout"
     {:name ::logout}]
    ["upgrade"
     {:name ::upgrade}]
    ["search"
     {:name ::search}]
    ["page"
     [""
      {:name ::page-index}]
     ["/:page-id"
      {:name ::page
       :parameters {:path {:page-id string?}}}]]
    ["playlist"
     ["/:playlist-id"
      {:name ::playlist-page
       :parameters {:path {:playlist-id uuid?}}}]]]))

(defn navigate-to!
  "Given a path. Navigates to it.
  For more info visit https://cljdoc.org/d/metosin/reitit/0.7.0-alpha5/api/reitit.frontend.easy "
  [{:keys [path-name opts] :as _config}]
  (do-nav path-name opts))

(defn replace-state
  [& args]
  (apply do-replace args))

(def ^:private stop-navigation-back-routes
  "The navigating back event is supressed when
  the last route is one of these.

  For now, both login and first loaded page are
  represented by `/`. So this route prevents both
  cases."
  #{"/"})

(defn- should-navigate-back? [last-route]
  (not (contains? stop-navigation-back-routes last-route)))

(defn back-navigation!
  [& _args]
  (when-let [last-fragment (-> @rfe/history :last-fragment)]
    (when (should-navigate-back? @last-fragment)
      (js/history.back))))

(defn- on-navigate
  [{:keys [data path-params redirect] :as _reitit-match}]
  ;; here we don't pass the whole clj reitit object to the worker
  (let [sent-data {:data (select-keys data [:name])
                   :path-params path-params
                   :redirect redirect}]
    (rf/dispatch [::route-changed sent-data])))

(def router-opts
  {:use-fragment use-fragment})

(defn start!
  []
  (rfe/start! routes on-navigate router-opts))
